import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CallCenterPatient, CurrentPatientProvider, Spinner, } from "@madmedical/ui";
import { adaptPatient, usePatient } from "@madmedical/user";
import { invariant } from "@madmedical/utils";
import { useState } from "react";
import UpdateDeviceForm from "./UpdateDeviceForm";
import { useGetLogisticsDevicesQuery } from "./api";
import adaptDevice from "./adaptDevice";
var Modal;
(function (Modal) {
    Modal[Modal["Closed"] = 0] = "Closed";
    Modal[Modal["EditDevice"] = 1] = "EditDevice";
})(Modal || (Modal = {}));
const Patient = () => {
    const { patientId, patient, isLoading: isPatientLoading } = usePatient();
    const { data: devicesData, isLoading: isDevicesLoading } = useGetLogisticsDevicesQuery({ patientId, pageSize: 5000 });
    const [modal, setModal] = useState(Modal.Closed);
    const [deviceIdForModal, setDeviceIdForModal] = useState();
    const handleEditPress = (id) => {
        setDeviceIdForModal(id);
        setModal(Modal.EditDevice);
    };
    const handleModalClose = () => {
        setDeviceIdForModal(undefined);
        setModal(Modal.Closed);
    };
    if (isPatientLoading || isDevicesLoading) {
        return _jsx(Spinner, {});
    }
    invariant(patient);
    invariant(devicesData);
    return (_jsxs(_Fragment, { children: [_jsx(CurrentPatientProvider, Object.assign({ value: { patient: adaptPatient(patient) } }, { children: _jsx(CallCenterPatient, { devices: devicesData.items.map(adaptDevice), onEditPress: handleEditPress }) })), " ", deviceIdForModal && (_jsx(UpdateDeviceForm, { id: deviceIdForModal, open: modal === Modal.EditDevice, onClose: handleModalClose }))] }));
};
export default Patient;
